var triggers = $(".MediaTabs__link"),
    tabs = $('.MediaTabs__tab'),
    triggerClass = 'MediaTabs__link--active',
    tabClass = 'MediaTabs__tab--active';

function triggerTab(e){

    e.preventDefault();

    if($(this).hasClass(triggerClass)){
        return;
    }

    var target = $(this).attr('href');

    triggers.filter('.'+triggerClass).removeClass(triggerClass);
    triggers.filter('[href="'+target+'"]').addClass(triggerClass);

    tabs.filter('.'+tabClass).removeClass(tabClass);
    tabs.filter(target).addClass(tabClass);
}

triggers.on('click', triggerTab);
